import { render, staticRenderFns } from "./EmployeeFolderFloatBtns.vue?vue&type=template&id=29938b6c&"
import script from "./EmployeeFolderFloatBtns.vue?vue&type=script&lang=js&"
export * from "./EmployeeFolderFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports